module.exports = __webpack_public_path__ + "img/logo-white.b28deb6e.svg";